module.exports = __webpack_public_path__ + "static/media/loading1.25ccf486.svg";